<template>
  <div class="authentication_wrap">
    <div>
      <companyInformation :userInfo="userInfo" @succe="succe"></companyInformation>
    </div>
    <el-divider></el-divider>
    <div>
      <CompanyProfile :userInfo="userInfo" @succe="succe" />
    </div>
    <el-divider></el-divider>
    <div>
      <EforcementInformation :userInfo="userInfo" @succe="succe" />
    </div>
    <el-divider></el-divider>
    <div>
      <BusinessLicense :userInfo="userInfo" @succe="succe" />
    </div>
    <el-divider></el-divider>
    <div>
      <Cooperation :userInfo="userInfo" @succe="succe" />
    </div>
    <div v-if="userInfo.auditStatus !==1" class="subBtn" @click="goAuthentication">{{subBtn}}</div>
    <div v-if="userInfo.auditStatus ===1" class="subBtn1" @click="goAuthentication"><i></i>认证通过</div>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from "lodash.debounce"; // 防抖函数
import provinceJson from '@/assets/js/provinceJson'
import companyInformation from '../MemberCertificationCompany/companyInformation' // 企业信息
import CompanyProfile from '../MemberCertificationCompany/CompanyProfile' // 企业简洁
import EforcementInformation from '../MemberCertificationCompany/EforcementInformation' // 法人信息
import BusinessLicense from '../MemberCertificationCompany/BusinessLicense' // 营业执照
import Cooperation from '../MemberCertificationCompany/Cooperation' // 合作意向

export default {
  components: {
    companyInformation,
    CompanyProfile,
    EforcementInformation,
    BusinessLicense,
    Cooperation
  },
  data () {

    return {
      userInfo: {},
      myUser: {},
      subBtn: ""
    };
  },
  async created () {
    this.myUser = JSON.parse(localStorage.getItem("myUser"))
    await this.registerInfo(this.myUser.id)
  },

  methods: {
    succe (value) {
      value.num = 1
      if (value.auditStatus === 0) {
        this.$message({
          message: "您修改的认证内容已经更新并提交~",
          type: "success"
        });
      }
      this.userInfo = value
      if (this.userInfo.auditStatus === 2) {
        this.subBtn = "提交认证"
      }

    },
    // 拉取认证
    async registerInfo (userId) {
      let url = "/v1/userRegister/get_company_register_info"// 企业拉去信息
      let params = {
        userId
      }
      try {
        const { resultCode, result } = await this.catReq1Service(url, params, "get")
        if (resultCode === "1") {
          this.userInfo = result
          this.userInfo.num = 1
          //
          if (result.auditStatus === null || result.auditStatus === 2) {
            this.subBtn = "提交认证"
          } else if (result.auditStatus === 0) {
            this.subBtn = "审核中"
          } else if (result.auditStatus === 1) {
            this.subBtn = "认证完成"
          }
        }

      } catch (error) {

      }
    },

    // 认证 ---- 企业
    async goAuthentication () {
      let that = this
      if (this.userInfo.auditStatus === 0) {
        this.$message.closeAll();
        that.$message({
          message: "您修改的认证内容已经更新并提交~",
          type: "warning"
        });
        return
      }
      if (this.userInfo.auditStatus === 1) {
        this.$message.closeAll();
        that.$message({
          message: "认证通过不可修改",
          type: "warning"
        });
        return
      }

      if (!this.userInfo) {
        this.$message.closeAll();
        that.$message({
          message: "信息不完整暂不能认证",
          type: "warning"
        });
        return
      }
      let isEmpty = false;
      let _this = this

      if (_this.userInfo.companyName == null || _this.userInfo.companyName == "") {
        isEmpty = true
      }
      if (_this.userInfo.taxpayerId == null || _this.userInfo.taxpayerId == "") {
        isEmpty = true
      }
      if (_this.userInfo.companyAddress == null || _this.userInfo.companyAddress == "") {
        isEmpty = true
      }
      if (_this.userInfo.collaborateTypes == null || _this.userInfo.collaborateTypes.length === 0) {
        isEmpty = true
      }
      if (_this.userInfo.businessLicenseUrls == null || _this.userInfo.businessLicenseUrls.length === 0) {
        isEmpty = true
      }
      //taxpayerId companyAddress  collaborateTypes
      if (isEmpty) {//值全为空
        _this.$message({
          message: "信息不完整暂不能认证",
          type: "warning"
        });
        return
      }
      let url = "/v1/userRegister/add_or_update_company_register_info"
      let params = {
        id: _this.userInfo.id,
        userId: _this.userInfo.userId,
        auditStatus: 0,
        businessLicenseUrls: _this.userInfo.businessLicenseUrls
      }
      const res = await this.catReq1Service(url, params)
      if (res.resultCode === "1") {
        _this.$message({
          message: "已提交审核",
          type: "warning"
        });

        this.subBtn = "审核中"
        // this.reload()
        return
      }
    },
  }
};
</script>

<style lang="less" scoped>
.authentication_wrap {
  width: 77%;
  margin: 0 auto;
  text-align: left;
  .subBtn {
    text-align: center;
    width: 100px;
    height: 36px;
    background: rgba(30, 134, 230, 1);
    box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
    border-radius: 4px;
    font-size: 16px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .subBtn1 {
    width: 100px;
    height: 36px;
    background: #37bd6d;
    box-shadow: 0px 1px 1px 0px rgba(55, 189, 109, 0.3);
    border-radius: 4px;
    font-size: 16px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    i {
      width: 23px;
      height: 23px;
      display: inline-block;
      vertical-align: middle;
      background: url("../../assets/imgs/authentication/affirm_clickable_icon.png")
        no-repeat;
      background-size: cover;
    }
  }
}
</style>
